module.exports = __webpack_public_path__ + "img/icon-condition-house.3f6e6470.svg";